import { useSearchParams, Navigate } from "react-router-dom";
import { BookEditorProvider } from "./editor/BookEditorProvider";
import UnifiedBookEditor from "./editor/UnifiedBookEditor";
import { resolveBookEditorMode, bookLabHomeUrl } from "../../lib/bookLabRoutes";

/**
 * Unified Book Lab editor entry.
 *   mode=write|design|canvas|preview  (canonical)
 *   view=writer → write, view=canvas → canvas  (legacy)
 * Same bookId across all modes — no document copy.
 */
export default function EditorWorkspace() {
  const [params] = useSearchParams();
  const bookId = params.get("bookId");
  const mode = resolveBookEditorMode(params);

  if (!bookId) {
    return <Navigate to={bookLabHomeUrl()} replace />;
  }

  return (
    <BookEditorProvider bookId={bookId} initialMode={mode}>
      <UnifiedBookEditor />
    </BookEditorProvider>
  );
}
